<div class="body">
    <div *ngIf="!this.muestraMenu" class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">
        <mat-card-header>
            <mat-card-title> Estamos trabajando en una mantención del sistema, pronto volveremos a estar disponibles. </mat-card-title>
        </mat-card-header> <br/>
    </div>    
    <div *ngIf="this.muestraMenu" class="login-wrapper" fxLayout="row" fxLayoutAlign="center center">

        <mat-card class="box">

            <div class="btn-group btn-group-toggle btn-block" data-toggle="buttons" style="margin-bottom: 40px; margin-left:-12%">

                <label class="btn btn-primary active">
                    <input type = "radio" name = "options" (click) = "cambiaMensaje('afiliado')" autocomplete="off" checked> Funcionario
                </label>

                <label class="btn btn-primary">
                    <input type = "radio" name = "options" (click) = "cambiaMensaje('ejecutivo')" autocomplete="off"> Ejecutivo
                </label>

                <label class="btn btn-primary">
                    <input type = "radio" name = "options" (click) = "cambiaMensaje('jubilado')" autocomplete="off"> Jubilado
                </label>

            </div>

            <mat-card-header>

                <mat-card-title> Bienestar </mat-card-title>

            </mat-card-header> <br/>

            <form class="example-form">

                <button mat-stroked-button class="btn-block" (click)="login()" *ngIf="!jubilado"> {{mensajeBoton}} </button>

                <img class="btn" src="assets/img/clave.png" (click)="login()" style="width:100%" *ngIf="jubilado" />

            </form>

        </mat-card>

    </div>

</div>